import { cn } from '@zep-us/zus';
interface AuthCardLayoutProps {
  children: React.ReactNode;
  /** 외부 컨테이너 추가 클래스 (pt, pb 등) */
  outerClassName?: string;
  /** 카드 컨테이너 추가 클래스 (py, pt, pb 등) */
  cardClassName?: string;
}

/**
 * Auth 페이지 공통 카드 레이아웃
 *
 * 기본 스타일:
 * - 외부: flex min-h-screen flex-col items-center justify-center bg-neutral pt-2xl pb-4xl px-2xl mobile-lg:px-md
 * - 카드: flex w-full max-w-[450px] flex-col items-center gap-sm rounded-lg bg-default px-lg mobile-lg:px-xl shadow-xs
 *
 * 사용 예시:
 * - 기본: <AuthCardLayout cardClassName="pb-lg pt-2xl">
 * - 확장 패딩: <AuthCardLayout outerClassName="pt-2xl pb-4xl" cardClassName="py-2xl">
 */
export function AuthCardLayout({
  children,
  outerClassName,
  cardClassName
}: AuthCardLayoutProps) {
  return <div className={cn('flex min-h-screen flex-col items-center justify-center bg-neutral pt-2xl pb-4xl mobile-lg:px-2xl px-md', outerClassName)} data-sentry-component="AuthCardLayout" data-sentry-source-file="AuthCardLayout.tsx">
      <div className={cn('flex w-full max-w-[450px] flex-col items-center gap-sm rounded-lg bg-default px-lg mobile-lg:px-xl shadow-xs', cardClassName)}>
        {children}
      </div>
    </div>;
}